/** Filtri e ordinamento della collezione: aggiornano la griglia via Section Rendering API senza ricaricare. */
(() => {
  'use strict';

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.grid = this.querySelector('[data-facets-grid]');
      this.drawer = this.querySelector('#FacetsDrawer');
      this.form = this.querySelector('[data-facets-form]');
      this.bind();
      window.addEventListener('popstate', () => this.load(window.location.href, false));
    }

    bind() {
      const opener = this.querySelector('[data-facets-open]');
      if (this.drawer && opener) {
        opener.addEventListener('click', () => {
          this.drawer.showModal();
          opener.setAttribute('aria-expanded', 'true');
          this.release = window.themeTrapFocus(this.drawer, this.drawer.querySelector('[data-facets-close]'));
        });
        this.drawer.querySelector('[data-facets-close]')?.addEventListener('click', () => this.drawer.close());
        this.drawer.addEventListener('click', (e) => {
          if (e.target === this.drawer) this.drawer.close();
        });
        this.drawer.addEventListener('close', () => {
          opener.setAttribute('aria-expanded', 'false');
          this.release?.();
          opener.focus();
        });
      }
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.load(this.formUrl());
          this.drawer?.close();
        });
        this.form.addEventListener('change', window.themeDebounce(() => this.load(this.formUrl()), 400));
      }
      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facets-link]');
        if (!link) return;
        e.preventDefault();
        link.closest('details')?.removeAttribute('open');
        this.load(link.href);
        this.drawer?.close();
      });
    }

    formUrl() {
      const params = new URLSearchParams(new FormData(this.form));
      for (const [k, v] of [...params]) if (v === '') params.delete(k);
      return `${this.form.action.split('?')[0]}?${params.toString()}`;
    }

    async load(url, push = true) {
      this.grid?.classList.add('is-loading');
      try {
        const u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', this.sectionId);
        const res = await fetch(u.toString());
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('facet-filters');
        if (!fresh) return;
        ['[data-facets-grid]', '[data-facets-active]', '[data-facets-count]', '[data-facets-body]', '.collection__topbar'].forEach((sel) => {
          const a = this.querySelector(sel);
          const b = fresh.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });
        if (push) history.pushState({}, '', url);
        this.bindTopbar();
        window.themeObserveReveal?.(this);
        document.dispatchEvent(new CustomEvent('theme:facets:updated'));
        this.querySelector('.collection__topbar')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } finally {
        this.grid?.classList.remove('is-loading');
      }
    }

    bindTopbar() {
      const opener = this.querySelector('[data-facets-open]');
      if (opener && this.drawer) {
        opener.addEventListener('click', () => {
          this.drawer.showModal();
          this.release = window.themeTrapFocus(this.drawer, this.drawer.querySelector('[data-facets-close]'));
        });
      }
    }
  }
  customElements.define('facet-filters', FacetFilters);
})();
